import styled from 'helpers/styles';
import PropTypes from 'prop-types';
import ComponentStyles from 'styles/mixins/Component.styles';
import Kanban from 'components/organisms/Kanbans/Kanban/Kanban';

const StyledDealflowKanban = styled(Kanban)`
  ${ComponentStyles}
`;

StyledDealflowKanban.propTypes = {
  theme: PropTypes.object
};

export default StyledDealflowKanban;
